import { Set as ImmutableSet } from 'immutable';
import { DOCUMENT_CREATE_STARTED, DOCUMENT_CREATE_SUCCEEDED, DOCUMENT_CREATE_FAILED, DOCUMENTS_DELETE_SUCCEEDED, DOCUMENTS_CHIRP_REMOVE_SUCCEEDED, DOCUMENTS_USAGE_FETCH_SUCCEEDED, DOCUMENTS_USAGE_CHIRP_FETCH_SUCCEEDED, FETCH_DOCUMENT_DESCRIPTION_SUCCEEDED, FETCH_DOCUMENT_DESCRIPTION_FAILED, FETCH_DOCUMENT_DESCRIPTION_CHIRP_SUCCEEDED, FETCH_DOCUMENT_DESCRIPTION_CHIRP_FAILED, TOGGLE_DOCUMENT_DESCRIPTION } from 'documents-lib/js/constants/ActionTypes';
export const initialState = {
  usage: null,
  indexDocuments: null,
  documentsUploading: ImmutableSet(),
  deckId: null,
  deckTitle: '',
  description: {
    hasError: false,
    isLoading: false,
    isPanelOpen: false,
    isUserEdited: false,
    text: ''
  },
  descriptionCHIRP: {
    hasError: false,
    isLoading: false,
    isPanelOpen: false,
    isUserEdited: false,
    text: ''
  }
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case DOCUMENT_CREATE_STARTED:
      {
        const newState = Object.assign({}, state, {
          documentsUploading: state.documentsUploading.add(action.payload)
        });
        if (!state.usage) {
          return newState;
        }
        return Object.assign({}, newState, {
          usage: Object.assign({}, state.usage, {
            count: state.usage.count + 1
          })
        });
      }
    case DOCUMENT_CREATE_SUCCEEDED:
      return Object.assign({}, state, {
        documentsUploading: state.documentsUploading.delete(action.payload)
      });
    case DOCUMENT_CREATE_FAILED:
      {
        const newState = Object.assign({}, state, {
          documentsUploading: state.documentsUploading.delete(action.payload)
        });
        if (!state.usage) {
          return newState;
        }
        return Object.assign({}, newState, {
          usage: Object.assign({}, state.usage, {
            count: state.usage.count - 1
          })
        });
      }
    case DOCUMENTS_DELETE_SUCCEEDED:
    case DOCUMENTS_CHIRP_REMOVE_SUCCEEDED:
      {
        if (!state.usage) {
          return state;
        }
        return Object.assign({}, state, {
          usage: Object.assign({}, state.usage, {
            count: state.usage.count - action.payload.length
          })
        });
      }
    case DOCUMENTS_USAGE_FETCH_SUCCEEDED:
      {
        return Object.assign({}, state, {
          usage: {
            count: action.payload.get('currentUsage'),
            limit: action.payload.get('limit'),
            userLimit: action.payload.get('userLimit')
          }
        });
      }
    case DOCUMENTS_USAGE_CHIRP_FETCH_SUCCEEDED:
      {
        const {
          currentUsage,
          limit,
          userLimit
        } = action.payload;
        return Object.assign({}, state, {
          usage: {
            count: currentUsage,
            limit,
            userLimit
          }
        });
      }
    case FETCH_DOCUMENT_DESCRIPTION_SUCCEEDED:
      {
        // document does not have a saved description
        if (!action.payload) {
          return Object.assign({}, state, {
            description: Object.assign({}, state.description, {
              isLoading: false
            })
          });
        }
        return Object.assign({}, state, {
          description: Object.assign({}, state.description, {
            isLoading: false,
            isUserEdited: action.payload.isUserEdited,
            text: action.payload.text
          })
        });
      }
    case FETCH_DOCUMENT_DESCRIPTION_FAILED:
      {
        return Object.assign({}, state, {
          description: Object.assign({}, state.description, {
            hasError: true,
            isLoading: false
          })
        });
      }
    case FETCH_DOCUMENT_DESCRIPTION_CHIRP_SUCCEEDED:
      {
        var _action$payload$isUse;
        if (!action.payload) {
          return Object.assign({}, state, {
            descriptionCHIRP: Object.assign({}, state.descriptionCHIRP, {
              isLoading: false
            })
          });
        }
        return Object.assign({}, state, {
          descriptionCHIRP: Object.assign({}, state.descriptionCHIRP, {
            isLoading: false,
            isUserEdited: (_action$payload$isUse = action.payload.isUserEdited) !== null && _action$payload$isUse !== void 0 ? _action$payload$isUse : false,
            text: action.payload.text
          })
        });
      }
    case FETCH_DOCUMENT_DESCRIPTION_CHIRP_FAILED:
      {
        return Object.assign({}, state, {
          descriptionCHIRP: Object.assign({}, state.descriptionCHIRP, {
            hasError: true,
            isLoading: false
          })
        });
      }
    case TOGGLE_DOCUMENT_DESCRIPTION:
      {
        if (action.payload.isOpen) {
          return Object.assign({}, state, {
            deckId: action.payload.deckId,
            deckTitle: action.payload.deckTitle,
            description: Object.assign({}, initialState.description, {
              isPanelOpen: true,
              isLoading: true
            }),
            descriptionCHIRP: Object.assign({}, initialState.descriptionCHIRP, {
              isPanelOpen: true,
              isLoading: true
            })
          });
        } else {
          return Object.assign({}, state, {
            deckId: null,
            deckTitle: '',
            description: Object.assign({}, initialState.description),
            descriptionCHIRP: Object.assign({}, initialState.descriptionCHIRP)
          });
        }
      }
    default:
      return state;
  }
});